import React, { useState, useEffect } from "react";
import { useAdmin } from "../../context/contextAdmin";
import Mail from './mail'
import SignIn from './signin'

export default function SignInAdmin() {
  const { signInAdmin } = useAdmin();
  
  return (
    <div>
      {signInAdmin ? <Mail /> : <SignIn />}
    </div>
  );
}
